
import MGW_PL_White  from '../MGW_PL_White.png'

export default function Logo(){
    return <img src={MGW_PL_White} className="logo" style={{width:"25vw", zIndex:500, objectFit:"cover"}}></img>
}